import { parseQueryString, replaceQueryString } from "@common/lib/url";
import { isUndefined } from "lodash";
import { type VimeoVideoProps } from "./component";

export const getSrc = (props: VimeoVideoProps): string => {
  let url = props.url || `//player.vimeo.com/video/${props.videoId}`;

  const qs = parseQueryString(url) || {};
  if (url.includes("//vimeo.com")) {
    const match = url.match(/\/\/vimeo.com\/([^/?]+)/)!;
    url = `//player.vimeo.com/video/${match[1]}`;
  }

  if (props.isBackground) {
    return replaceQueryString(url, { ...qs, background: 1 });
  }

  return replaceQueryString(url, {
    ...qs,
    autoplay: props.autoPlay ? 1 : 0,
    controls: props.showControls || isUndefined(props.showControls) ? 1 : 0,
    loop: props.loop ? 1 : 0,
    muted: props.autoPlay ? 1 : props.mute ? 1 : 0,
    autopause: 0
  });
};

export const isVimeoURL = (url: string | null | undefined) =>
  (url || "").includes("//player.vimeo.com") || (url || "").includes("//vimeo.com");
